<template>
    <div class="mine-content">
        <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png"/></span>My Wallets</div>
        <div class="second-pard">
            <ul @click="util.topage('/bankwallet')">
              <li><img src="@/assets/images/user/mine/bank.png"/></li>
              <li>Bank Wallet</li>
              <li></li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul>  
            <ul @click="util.topage('/digitalwallet')">
              <li><img src="@/assets/images/user/mine/digital.png"/></li>
              <li>Digital Wallet</li>
              <li></li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul>
        </div>
        <van-loading
        v-show="showloding"
        size="50px"
        color="#1989fa"
        vertical/>
    </div>
    </template>
    <script>
    import Vue from "vue";
    import { Loading } from "vant";
    Vue.use(Loading);
    export default {
      data() {
        return { showloding: false };
      },
    };
    </script>
    <style lang="scss" scoped>
    .mine-content{
      font-size: 0.32rem;
      background: rgb(235, 235, 235);
      color:rgb(103, 103, 103);
      width: 100%;
      height: 100%;
      .mine-header{
        color:black;
        font-weight: bold;
        height: 1rem;
        display: grid;
        grid-template-columns: 30% 1fr 30%;
        align-items: center;
        text-align: center;
        .back{
          cursor: pointer;
          img{
            display: block;
            margin-left: 5%;
            width: 0.5rem;
            transform: rotate(180deg);
          }
        }
      }
      .second-pard{
        background: white;
        ul{
          display: grid;
          font-size: 0.34rem;
          grid-template-columns: 12% 3rem 1fr 12%;
          border-bottom: 1px solid rgb(238, 238, 238);
          cursor: pointer;
          li{
            display: flex;
            align-items: center;
            height: 1.2rem;
          }
          :nth-child(1){
            margin-left: 20%;
            margin-right: auto;
            img{
              display: block;
              margin: auto;
              width:0.65rem;
              height:0.6rem;
            }
          }
          :nth-child(3){
            margin-left: auto;
            img{
              border-radius: 100%;
              display: block;
              width:1rem;
            }
          } 
          :nth-child(4){
            img{
              display: block;
              margin: auto;
              width:0.5rem;
            }
          }
        }
      }
    }
    </style>  